<div class="flex-auto bg-card p-6">
    <div class="flex flex-col border-b border-gray-200 mb-4">
        <span class="text-xl font-semibold">{{ tituloCabecera }}</span>
        <span class="text-gray-400 text-sm">{{ titulo }}</span>
    </div>

    <form #tipologiaForm="ngForm" (ngSubmit)="submit(tipologiaForm)" class="grid grid-cols-1 md:grid-cols-2 gap-2" novalidate>
        <mat-form-field class="md:col-span-2 fuse-mat-dense">
            <mat-label>Descripcion</mat-label>
            <input
                matInput
                name="descripcion"
                required
                [(ngModel)]="model.descripcion"
                #descripcion="ngModel"
            />
            <mat-error *ngIf="descripcion.invalid && descripcion.touched">Requerido</mat-error>
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense">
            <mat-label>Prefijo</mat-label>
            <input matInput name="valor1" [(ngModel)]="model.valor1" />
        </mat-form-field>

        <mat-form-field class="fuse-mat-dense">
            <mat-label>Correlativo</mat-label>
            <input matInput name="valor2" [(ngModel)]="model.valor2" />
        </mat-form-field>

        <div class="md:col-span-2 flex items-center gap-4 pt-4 justify-end">
            <button mat-stroked-button type="button" (click)="dialogRef.close()">Cancelar</button>
            <button mat-flat-button color="primary" type="submit" [disabled]="!tipologiaForm.valid">
                Guardar
            </button>
        </div>
    </form>
</div>
